const q = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

const LINE_HEAD = ["part_code", "description", "qty", "order_type", "order_number", "status", "ordered_on", "expected_on",
  "received_on", "order_to_arrival_days", "waiting_days", "delivered_on", "arrival_to_fitted_days", "overdue"];
const lineCells = (l) => [l.part_code, l.description, l.qty, l.order_type, l.order_number, l.status, l.ordered_on,
  l.expected_on, l.received_on, l.days_to_arrive, l.days_waiting, l.delivered_on, l.days_to_fit, l.overdue ? "YES" : ""];

// One CSV row per part line, prefixed with its job card / advance details.
export function buildPartsCsv(tab, data) {
  const rows = tab === "jc"
    ? [["jc_no", "jc_status", "jc_date", "closed_on", "jc_duration_days", "branch", "customer", "vehicle_reg_no", "advance_no", ...LINE_HEAD],
      ...data.job_cards.flatMap((r) => r.lines.map((l) => [r.jc_no, r.jc_status, r.jc_date, r.closed_on, r.jc_duration_days,
        r.branch_name, r.customer_name, r.vehicle_reg_no, l.advance_no, ...lineCells(l)]))]
    : [["advance_no", "advance_type", "date", "branch", "customer", "phone", "vehicle_reg_no", "jc_no", "advance_amount", "advance_remaining", ...LINE_HEAD],
      ...data.advances.flatMap((r) => r.lines.map((l) => [r.advance_no, r.advance_type, r.date, r.branch_name, r.customer_name,
        r.customer_phone, r.vehicle_reg_no, r.jc_no, r.advance_amount, r.advance_remaining, ...lineCells(l)]))];
  return rows.map((r) => r.map(q).join(",")).join("\n");
}

export function downloadCsv(csv, name) {
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
